<template>
	<div id="sidebar">
		<h1>
      <router-link to="/">
        <mt-logo :propWidth="80"/>
      </router-link>
    </h1>

    <!-- <h2 class="mt--neutrals-dark-gray-02">Style</h2> -->
    <h3
      class="mt--neutrals-dark-gray-02"
      @click="openStyleMenu = !openStyleMenu">
      Style
      <mt-icon :iconName="styleToggleIcon" color="#718091"/>
    </h3>
    <ul :class="openStyleMenu? 'on' : 'off'" :style="stylesStyle">
      <li
        v-for="item in styles" :key="item.label"><router-link :to="`/${item.route}`">{{item.label}}</router-link>
      </li>
    </ul>
    <h3
      class="mt--neutrals-dark-gray-02"
      @click="openComponentsMenu = !openComponentsMenu"
      >
      Components
      <mt-icon :iconName="componentsToggleIcon" color="#718091"/>
    </h3>
    <ul :class="openComponentsMenu? 'on' : 'off'" :style="componentsStyle">
      <li
        v-for="item in components" :key="item.label"><router-link :to="`/${item.route}`">{{item.label}}</router-link>
      </li>

    </ul>
	</div>
</template>

<script>

export default {
	name: 'sidebar',
	props: [],
	components: {

	},
	data () {
		return {
      openStyleMenu: true,
      openComponentsMenu: true,
      styles: [
        {label: 'Logos', route: 'logos'},
        {label: 'Colors', route: 'colors'},
        {label: 'Typography', route: 'typography'},
        {label: 'Iconography', route: 'iconography'},
      ],
      components: [
        {label: 'Buttons', route: 'buttons'},
        {label: 'Notification', route: 'notification'},
        {label: 'Modals', route: 'modals'},
        {label: 'Checkbox', route: 'checkbox'},
        {label: 'Radio Button', route: 'radiobutton'},
        {label: 'Confirm', route: 'confirm'},
        //{label: 'Select', route: 'select'},
        {label: 'Text Input', route: 'input'},
      ],
		}
	},
	computed: {
    styleToggleIcon() {
      let iconName = 'chevron-up'
      if(!this.openStyleMenu) iconName = 'chevron-down'
      return iconName
    },
    componentsToggleIcon() {
      let iconName = 'chevron-up'
      if(!this.openComponentsMenu) iconName = 'chevron-down'
      return iconName
    },
    componentsStyle(){
      return {height: 49*this.components.length + 'px'}
    },
    stylesStyle(){
      return {height: 49*this.styles.length + 'px'}
    },
	},

	methods: {

  }

}
</script>
<style scoped lang="scss">
@import "../plugins/mtui/styles/Variables.scss";
a {
  text-decoration: none;
}
h1 {
  padding: 20px;
  margin: 0;
}
h2, h3 {
  font-size: 14px;
}
h2 {
  padding-left: 20px;
}
h3 {
  padding-left: 37px;
  padding-top: 20px;
  cursor: pointer;
  position: relative;
  .mt-icon {
    float: right;
    padding-right: 2em;
    position: absolute;
    right: 0;
    top: 17px;
  }
}
ul {
  display: block;
  overflow: hidden;
  transition: height 600ms ease-out;
  .router-link-active {
    color: $c-primary;
    background-color: $c-neutrals-light-gray-01;
  }
}
ul.off {
  height: 0!important;
}
li a {
  color: $c-neutrals-dark-gray-02;
  font-size: 14px;
  padding: 16px 44px;
  display: block;
  &:hover {
    background-color: $c-neutrals-light-gray-01;
  }
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?21d658c7